<template>
    <svg
        aria-hidden="true"
        width="24"
        height="24">
        <use :xlink:href="`/assets/svg/icon.svg?9#${name}`"></use>
    </svg>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import type { TAtomIcon } from '~/components/atom/atom-icon/atom-icon.types'

defineProps({
    /**
     * Название иконки
     */
    name: {
        type: String as PropType<TAtomIcon>,
        required: true,
    },
})
</script>
